import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-mb-stat-box',
  imports: [NgIf],
  templateUrl: './mb-stat-box.component.html',
})
export class MbStatBoxComponent {
  @Input() number = '';
  @Input() name = '';
  @Input() last = false;
  // @Input() size: 'small' | 'large' = 'small';
}
